import { Button, Icon, Li, Router } from '@startlibs/components';
import _ from 'lodash/fp'
import { getColor, media } from '@startlibs/utils';
import { useToggle } from '@startlibs/core';
import {Route, Routes, useLocation, useNavigate, useParams} from '@startlibs/components';
import React, {Suspense, useState} from 'react'
import styled, {ThemeProvider} from 'styled-components';
import {EditExpert} from '../admin/experts/EditExpert'
import {ExpertAnswers} from './ExpertAnswers'
import {ExpertCaseList} from './ExpertCaseList'
import {ExpertOverview} from './ExpertOverview'
import {ExpertRemoteConsultation} from './ExpertRemoteConsultation'
import {ExpertReport} from './ExpertReport'
import {ExpertRequestSidebar} from './ExpertRequestSidebar'
import {NavbarTabs, UserNavbar} from '../components/Navbar'
import {PageContent, PageWrapper} from '../admin/steps/RequestSidebar'
import {ProviderTitle} from '../components/ProviderTitle'
import {getExpertDefaultPath} from '../enums/CaseState'
import {getTimezoneOffset} from '../utils/utils'
import {FormattedMessage, useIntl} from 'react-intl'
import {jwtGetFetcher, jwtPostFetcher} from '../utils/authFetch'
import { setJwt } from '../hooks/useJwt';
import {willUseSuspense} from '../hooks/useSuspense'
import {lazyMaybeUserInfo, lazyProviderInfo} from '../components/WithProvider';
import { ExpertSSOLogin } from '../admin/ExpertSSOLogin';
import { ExpertLogin } from '../admin/ExpertLogin';
import {Redirect} from "../components/Redirect";
import { ExpertReadOnlyOverview } from './ExpertReadOnlyOverview';

const DEV_JWT = import.meta.env.DEV && import.meta.env.VITE_DEV_JWT_EXPERT
const getJwt = () => window.JWT_URL_PARAM  || window.localStorage.getItem("expert-jwt") || DEV_JWT

export const FeedbackButton = styled(Button)`
  color: ${getColor('main')};
  font-size: 13px;
  box-shadow: none;
  margin-left: auto;
  margin-right: 0.75rem;
  padding-right: 0.75rem;
  align-self: center;
  ${Icon} {
    color: ${getColor('main')};
  }
  ${media.mobile`
    display: none;
  `}
`

export const ExpertRoutes = () => {
  let location = useLocation();
  let navigate = useNavigate();

  const providerInfo = lazyProviderInfo.read()

  if (getJwt()) {
    setJwt(getJwt(),"expert")
  }
  const jwt = getJwt()
  const intl = useIntl()
  const feedbackPopup = useToggle()
  const [showButton, setShowButton] = useState(true);

  if (location.pathname === "/expert/login") {
    return <ExpertLogin />
  }

  if ((location.pathname === "/expert/sso/login") && (providerInfo?.ssoEnabled === true || providerInfo?.ssoExpertEnabled === true)){
    // return <ExpertLogin />
    return <ExpertSSOLogin/>
  }

  if (!getJwt() || !lazyMaybeUserInfo.read()) {
    return (providerInfo?.ssoEnabled === true || providerInfo?.ssoExpertEnabled === true)
      ?
      <Redirect to="/expert/sso/login" />
      :
      <Redirect to="/expert/login" />
  }


  const addOrUpdateExpert = (expert) => console.log(expert) ||
    jwtPostFetcher(getJwt())('/api/expert', expert, {method: 'PUT'})

  const incompleteFooter =  (form, expert, providerInfo) => <>
    {((!providerInfo?.ssoEnabled) || expert.email.indexOf('@purview') >= 0) && <div className="left-block">
      <Button.a target="_top" href={`/api/expert/passettings?t=${jwt}&locale=${intl.locale}`}>
        <FormattedMessage defaultMessage="Account settings" description="Profile account settings button" />
      </Button.a>
    </div>}
    <div className="right-block">
      <Button.Link to="/expert">
        <FormattedMessage defaultMessage="Maybe later" description="Incomplete expert profile finish maybe later button" />
      </Button.Link>
      <Button isLoading={form.isLoading} highlight type="submit">
        <FormattedMessage defaultMessage="Finish profile" description="Incomplete expert profile finish 'finish' profile button" />
      </Button>
    </div>
  </>

  const expertFooter =  (form, expert, providerInfo) => <>
    
    {((!providerInfo?.ssoEnabled) || expert.email.indexOf('@purview') >= 0) && <div className="left-block">
      <Button.a target="_top" href={`/api/expert/passettings?t=${jwt}&locale=${intl.locale}`}>
        <FormattedMessage defaultMessage="Account settings" description="Profile account settings button" />
      </Button.a>
    </div>}
    <div className="right-block">
      <Button.Link to="/expert">
        <FormattedMessage defaultMessage="Cancel" description="Cancel button"/>
      </Button.Link>
      <Button isLoading={form.isLoading} highlight type="submit">
        <FormattedMessage defaultMessage="Update details" description="Profile update details button" />
      </Button>
    </div>
  </>

  return <>
    <UserNavbar
      withLocale
      indexUrl="/expert"
      resetPasswordUrl="/api/expert/resetPassword"
      // subtitle="Expert physician"
      subtitle={intl.formatMessage({defaultMessage:"Expert physician", description:"Expert header bar subtitle expert physicians"})}
      exitUrl={`/expert?locale=${intl.locale}`}
      routes={<>
        <NavbarTabs
          className="desktop-only"
          selected={location.pathname === '/expert'}
          to="/expert">
          <FormattedMessage defaultMessage="Cases" description="Expert navbar tab title" />
        </NavbarTabs>
      {showButton && <FeedbackButton icon="feedback" textOnly onClick={()=>{feedbackPopup.open()}}>
        <FormattedMessage defaultMessage="Give feedback" description="Expert navbar feedback button" />
      </FeedbackButton>}
      </>}
      extraContextMenuItem={<Li
        label={intl.formatMessage({defaultMessage:"Edit profile",description:"Edit profile navbar context menu item"})}
        linkTo="/expert/profile" />
      }
    />
    <ProviderTitle/>
    <Router>
      <Routes>
        <Route path="expert/case/:requestId" element={<ExpertCase feedbackPopup={feedbackPopup} setShowButton={setShowButton}/>} />
        <Route path="expert/case/:requestId/*" element={<ExpertCase feedbackPopup={feedbackPopup} setShowButton={setShowButton}/>} />
        <Route path="expert/profile/finish" element={<EditExpert onSuccess={() => navigate("/expert")} isIncomplete footer={incompleteFooter} isExpert action={addOrUpdateExpert} emptyId="" feedbackPopup={feedbackPopup}/>}/>
        <Route path="expert/profile" element={<EditExpert onSuccess={() => navigate("/expert")} isExpert footer={expertFooter} action={addOrUpdateExpert} emptyId="" feedbackPopup={feedbackPopup}/>}/>
        <Route path="*" element={<ExpertCaseList jwt={jwt} feedbackPopup={feedbackPopup} />}/>
      </Routes>
    </Router>
  </>
}


const useAuthSuspense = willUseSuspense((requestId) => jwtGetFetcher(getJwt())(`/api/viewCaseRequest?requestId=${requestId}&timezoneOffset=${getTimezoneOffset()}`))
const SuspenseStep = ({Component, ...props}) => <Suspense><Component {...props} /></Suspense>
const StableThemeProvider = ThemeProvider
const ExpertCase = ({feedbackPopup, setShowButton}) => {
  const params = useParams()
  const requestId = params[0]
  const [caseRequest, setCaseRequest] = useState(useAuthSuspense(requestId))

  return caseRequest && <StableThemeProvider theme={_.set('mobileSidebar',true)}>
    <PageWrapper responsiveWorkaround>
    <ExpertRequestSidebar caseRequest={caseRequest}/>
    <PageContent>
      <Routes>
        <Route path={`expert/case/${requestId}/remote-consultation`} element={<SuspenseStep Component={ExpertRemoteConsultation} setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup}/>}/>
        <Route path={`expert/case/${requestId}/overview`} element={
          caseRequest.isCoReview 
            ? <ExpertReadOnlyOverview setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup} path="overview"/>
            : <ExpertOverview setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup}/>
        }/>
        <Route path={`expert/case/${requestId}/questions`} element={<ExpertAnswers setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup}/>}/>
        <Route path={`expert/case/${requestId}/report`} element={<ExpertReport setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup} setShowButton={setShowButton}/>}/>
        <Route path={`expert/case/${requestId}/upload-report`} element={<ExpertReport setCaseRequest={setCaseRequest} caseRequest={caseRequest} feedbackPopup={feedbackPopup} setShowButton={setShowButton} uploadPDF/>}/>
        <Route path='*' element={<Redirect to={`/expert/case/${requestId}/${getExpertDefaultPath(caseRequest?.state)}`} replace/>}/>
      </Routes>
    </PageContent>
  </PageWrapper>
  </StableThemeProvider>
}